const CustomHeader = ({ children, title, className }) => {
    return (
        <div
            className={`flex flex-wrap md:flex-nowrap justify-between items-center !gap-6 800:h-[88px] 800:items-center !px-0 max-800:mb-10 ${className}`}
        >
            <h2 className="font-[450] text-[24px] text-[#161827] md:translate-y-2.5">{title}</h2>
            <div className="flex 800:ml-auto">{children}</div>
        </div>
    );
};

export default CustomHeader;
